/**
 * VC-12 r5: the door's "what you will be asked to capture" list in the customer's language. The be sends
 * `captureListI18n` (row i = `{locale: text}` for `captureList[i]`, the pack's languages only) on a case whose pack
 * declares languages; India cases carry no such key and the list is `captureList` exactly as before. A row the pack has
 * no text for in the chosen language shows the `captureList` row — the server's words, never a client-side guess.
 */
import type { ExchangeSummary } from '@/api/capture';

export function captureListLines(summary: Pick<ExchangeSummary, 'captureList' | 'captureListI18n'>, locale: string): string[] {
  const i18n = Array.isArray(summary.captureListI18n) ? summary.captureListI18n : null;
  return summary.captureList.map((row, i) => {
    const text = i18n?.[i]?.[locale];
    return typeof text === 'string' && text.trim() !== '' ? text : row;
  });
}
